/* Turbo Parts — reveal the 2nd product photo on card hover (desktop only).
 * Uses the theme's OWN slideshow controls ("Next slide" / "Previous slide") so it
 * never fights the slideshow's transforms. Touch devices keep native swipe. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;

  function ctrl(card, label) {
    return card.querySelector('slideshow-arrows [aria-label="' + label + '"]');
  }

  function bind(card) {
    if (card.dataset.tpHoverBound) return;
    if (card.querySelectorAll('.product-media-container').length < 2) return;  // single image
    card.dataset.tpHoverBound = '1';
    var advanced = false;
    card.addEventListener('mouseenter', function () {
      if (advanced) return;
      var n = ctrl(card, 'Next slide');
      if (n) { n.click(); advanced = true; }
    });
    card.addEventListener('mouseleave', function () {
      if (!advanced) return;
      var p = ctrl(card, 'Previous slide');
      if (p) p.click();
      advanced = false;
    });
  }

  var pending = false;
  function run() {
    pending = false;
    document.querySelectorAll('product-card').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // rebind for async-loaded grids / recommendations (debounced; bound cards are skipped)
  new MutationObserver(function () {
    if (!pending) { pending = true; setTimeout(run, 200); }
  }).observe(document.body, { childList: true, subtree: true });
})();
